import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Chip from 'Chip';
import NoSSR from 'react-no-ssr';
import Ad from '@ifeng-fe/ui_pc_ad';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import VideoArea from './videoArea';
import Content from './content';
import BottomSlide from './bottomSlide';
import styles from './index.css';
import { h5PageCount, addBackGuide } from 'ThreeTerminal_utils';
import { QQShare, WXGuideLayer } from 'ThreeTerminal_mobile_dynamic';
import ShareSucc from './content/shareSucc';
import { randomString } from '../../../utils/createUid';
import FixedIcon from '@ifeng-fe/container_content/common/client/fixedIcon';
// import TwoSessions from './twoSessions';
import ActivityBanner from './activityBanner';
import TvHall from './tvHall';
import { getBackUrl } from '@src/services/api';
import { cookie } from '@ifeng-fe/ui_base';

class Layout extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        qqShareCofig: {},
        twiceShareRecShow: false,
        openCookieType: '',
        // 截流视频白名单默认全部关闭状态
        // whiteListModeShow: false,
    };

    uid = randomString();

    gotoBackUrlHandle = async () => {
        const { content } = this.props;
        const keywords = content?.keywords || '';
        const backUrl = await getBackUrl(keywords, 'video');

        addBackGuide(backUrl);
    };

    getOpenTypeHandle = () => {
        try {
            if (cookie.get('openCookieType')) {
                this.setState({
                    openCookieType: cookie.get('openCookieType').toString(),
                });
            } else {
                const randomNum = Math.floor(Math.random() * 3) + 1;

                cookie.set('openCookieType', randomNum);
                this.setState({
                    openCookieType: randomNum.toString(),
                });
            }
        } catch (e) {
            this.setState({
                openCookieType: '1',
            });
        }
    };

    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
        const {
            content: {
                docData: { base62Id },
                videoInfo: { title, sharePosterUrl, guid, desc },
                isShare,
                isVideoShare,
                unfoldType,
            },
        } = this.props;
        const crowdid = this.getUrlParams(location.href).crowdid;
        const refValue = this.getUrlParams(location.href).ref || document.referrer;

        if (unfoldType.videoShareUnfold === '4') {
            // 定时关闭
            if (new Date().getTime() < new Date('2023/12/22 20:00:00').getTime()) {
                this.getOpenTypeHandle();
            } else {
                this.setState({
                    openCookieType: '1',
                });
            }
        } else {
            this.setState({
                openCookieType: unfoldType.videoShareUnfold,
            });
        }

        // 手凤不发送page统计
        if (isShare) {
            // 页面统计
            h5PageCount([
                {
                    datatype: isVideoShare ? 'vappsns_ex' : 'newsappsns',
                    behavior: 'page',
                    type: crowdid ? 'videoseries' : 'video',
                    other: {
                        id: base62Id ? `ucms_${base62Id}` : guid,
                        ref: encodeURIComponent(refValue),
                        url: encodeURIComponent(location.href),
                    },
                },
            ]);
        }

        const qqShareCofig = {
            title,
            img: sharePosterUrl || 'https://p1.ifengimg.com/29b92e35b2b20708/2017/51/ifengLogo300x300.jpg',
            desc: '',
            appType: isVideoShare ? 'videoApp' : 'newsApp',
            cb: () => {
                this.setState({
                    twiceShareRecShow: true,
                });
            },
        };

        this.setState({
            qqShareCofig,
        });

        this.gotoBackUrlHandle();
    }

    getUrlParams = (url) => {
        const result = {};
        const search = url.split('?')[1] || '';
        const params = search.split('&');
        let param = [];

        for (let i = 0, iLen = params.length; i < iLen; i++) {
            param = params[i].split('=');
            if (param.length === 2) {
                result[param[0]] = decodeURIComponent(param[1]);
            }
        }

        return result;
    };

    changeShow = () => {
        this.setState({
            twiceShareRecShow: false,
        });
    };

    render() {
        const {
            content,
            content: {
                docData,
                docData: { base62Id },
                videoInfo: { guid, title },
                fixedIcon,
                isVideoShare,
                unfoldType,
                lianghuiData,
                keywords,
                relatedRecommend,
                recommendVideoAd,
                safeLevel,
                isCloseAlgRec,
                activityOne,
                activityTwo,
                pageBottomPic,
                beforeVideoData,
                classV,
                fullScreenAd,
                isShare,
                recommendVideoTwoPic1Ad,
                recomVideoTopAd,
                sourceAlias,
                sourceReason,
                wemediaEAccountId,
                bottomSlideAd,
                hasCopyRight,
                readNumConfig,
            },
        } = this.props;
        const { qqShareCofig, twiceShareRecShow, bottomSlidesShow, openCookieType } = this.state;
        const downloads = isVideoShare
            ? {}
            : {
                  download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1453822808118',
                  downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8796',
              };
        const wxLaunch = (unfoldType && unfoldType.wxLaunch) || {};
        const wxLaunchConfig = {
            wxLaunchType: wxLaunch.wxLaunchType === '1' ? 'app' : 'weapp',
            wxLaunchSwitch: wxLaunch.wxLaunchSwitch === '1',
        };
        const wxLaunchType = wxLaunchConfig.wxLaunchType;
        const wxLaunchSwitch = wxLaunchConfig.wxLaunchSwitch;

        let slidesConfig = {
            isVideoShare,
            apiConfig: {
                type: 'video',
                from: 'share_relate_foot_video',
                n: 4,
                // proid: '',
                id: `ucms_${base62Id}`,
                // title,
                apiUrl: 'nine',
            },
            isLogoPic: true,
            insertSlideArr: [
                {
                    clickCount: {
                        behavior: 'action',
                        type: 'downopen',
                        other: {
                            ref: guid,
                            to: true,
                            kind: 'video',
                            url: typeof window === 'undefined' ? '' : encodeURIComponent(location.href),
                            rnum: '0',
                        },
                    },
                    downloads,
                    kind: 'share52202',
                    wxLaunchType,
                    wxLaunchSwitch,
                },
                {
                    clickCount: {
                        behavior: 'action',
                        type: 'downopen',
                        other: {
                            ref: guid,
                            to: true,
                            kind: 'video',
                            url: typeof window === 'undefined' ? '' : encodeURIComponent(location.href),
                            rnum: '0',
                        },
                    },
                    downloads,
                    kind: 'share52202',
                    wxLaunchType,
                    wxLaunchSwitch,
                },
                {
                    clickCount: {
                        behavior: 'action',
                        type: 'downopen',
                        other: {
                            ref: guid,
                            to: true,
                            kind: 'video',
                            url: typeof window === 'undefined' ? '' : encodeURIComponent(location.href),
                            rnum: '0',
                            downurl: encodeURIComponent(
                                'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1453822808118',
                            ),
                        },
                    },
                    downloads,
                    kind: 'share52202',
                    wxLaunchType,
                    wxLaunchSwitch,
                },
                {
                    clickCount: {
                        behavior: 'action',
                        type: 'downopen',
                        other: {
                            ref: guid,
                            to: true,
                            kind: 'video',
                            url: typeof window === 'undefined' ? '' : encodeURIComponent(location.href),
                            rnum: '0',
                        },
                    },
                    downloads,
                    kind: 'share52202',
                    wxLaunchType,
                    wxLaunchSwitch,
                },
            ],
        };
        const wxConfig = (unfoldType && unfoldType.wxGuideLayer) || {};
        const wxGuideCallAppConfig = {
            client: isVideoShare ? 'videoApp' : 'newsApp',
            docType: docData.type,
            pid: docData.guid,
            kind: 'share99',
            download: isVideoShare
                ? ''
                : 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1475599819841',
            downloadAd: isVideoShare
                ? ''
                : 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8826',
        };
        const wxGuideClickContinueConfig = {
            datatype: isVideoShare ? 'vappsns_ex' : 'newsappsns',
            behavior: 'action',
            type: 'carryon',
            other: {
                ref: `ucms_${docData.base62Id}`,
                kind: 'other',
            },
        };
        const wxGuideClickCallAppConfig = {
            datatype: isVideoShare ? 'vappsns_ex' : 'newsappsns',
            behavior: 'action',
            type: 'turnon',
            other: {
                ref: `ucms_${docData.base62Id}`,
                kind: 'other',
            },
        };

        if (fixedIcon && fixedIcon.bottomSlide && fixedIcon.bottomSlide.slideSwitch === '1') {
            slidesConfig.isLogoPic = false;
            slidesConfig.lastSlideData = {
                id: fixedIcon.bottomSlide.gotoUrl || '',
                type: 'web',
                newstype: 'web',
                thumbnailpic: fixedIcon.bottomSlide.picUrl || '',
                share: fixedIcon.bottomSlide.gotoUrl || '',
                kind: 'share01',
                // noPrefixKind: true,
                dlUrl: fixedIcon.bottomSlide.gotoUrl || '',
                clickCount: {
                    behavior: 'action',
                    type: 'downopen',
                    other: {
                        ref: `ucms_${content.base62Id}`,
                        kind: 'article',
                        url: typeof window === 'undefined' ? '' : encodeURIComponent(location.href),
                        plat: 'napp',
                    },
                },
                downloads,
                wxLaunchType,
                wxLaunchSwitch,
            };
        }
        const isHitBlack = safeLevel === 1;

        return (
            <Fragment>
                <VideoArea
                    whiteListModeShow={this.state.whiteListModeShow}
                    contentData={content}
                    uid={this.uid}
                    isHitBlack={isHitBlack}
                    slideConfig={fixedIcon.bottomSlide}
                    wxLaunch={wxLaunchConfig}
                    sourceAlias={sourceAlias}
                    sourceReason={sourceReason}
                    videoShareUnfold={openCookieType}
                    wemediaEAccountId={wemediaEAccountId}
                />
                {/* <TwoSessions
                    lianghuiData={lianghuiData}
                    wxLaunch={wxLaunchConfig}
                    base62Id={docData.base62Id}
                    isVideoShare={isVideoShare}
                /> */}
                {!isHitBlack && activityOne && activityOne.length > 0 && (
                    <ActivityBanner
                        isVideoShare={isVideoShare}
                        base62Id={docData.base62Id}
                        wxLaunch={wxLaunch}
                        activityOne={activityOne}
                    />
                )}
                {!isHitBlack && isShare && (
                    <NoSSR>
                        <div className={styles.whiteBg}>
                            <Ad content={recomVideoTopAd} />
                        </div>
                    </NoSSR>
                )}
                <NoSSR>
                    <Content
                        isHitBlack={isHitBlack}
                        relatedRecommend={relatedRecommend}
                        isCloseAlgRec={isCloseAlgRec}
                        ad={recommendVideoAd}
                        contentData={content}
                        wxLaunch={wxLaunchConfig}
                        uid={this.uid}
                        recommendVideoTwoPic1Ad={recommendVideoTwoPic1Ad}
                    />
                </NoSSR>
                {!isHitBlack && <TvHall isVideoShare={isVideoShare} />}
                {!isHitBlack && (
                    <BottomSlide
                        classV={classV}
                        pageBottomPic={pageBottomPic}
                        isVideoShare={isVideoShare}
                        base62Id={docData.base62Id}
                        wxLaunch={wxLaunchConfig}
                        noCloseIcon={true}
                        slidesConfig={slidesConfig}
                        ad={bottomSlideAd}
                    />
                )}
                <NoSSR>
                    <FixedIcon
                        type={fixedIcon.video}
                        link={fixedIcon.link}
                        image={fixedIcon.image}
                        clientLink={fixedIcon.clientLink}
                        pageType="artcile"
                        base62Id={base62Id}
                    />
                </NoSSR>
                <NoSSR>
                    <div className={styles.content_list}>
                        <Chip
                            id="200094"
                            type="struct"
                            title="小羊位配置维护"
                            groupName="小羊位配置维护"
                            translate="handleFixedIconData">
                            <div className={styles.chip_item} />
                        </Chip>
                        <Chip id="260182" type="struct" title="视频前贴片配置" groupName="视频前贴片配置">
                            <div className={styles.chip_item} />
                        </Chip>
                        <Chip id="260659" type="struct" title="阅读数维护项" groupName="阅读数维护项">
                            <div className={styles.chip_item} />
                        </Chip>
                    </div>
                </NoSSR>
                <NoSSR>{qqShareCofig.title && <QQShare content={qqShareCofig} />}</NoSSR>
                <NoSSR>
                    {twiceShareRecShow ? (
                        <ShareSucc content={docData} isVideoShare={isVideoShare} change={this.changeShow} />
                    ) : null}
                </NoSSR>
                {!isHitBlack && !isShare && (
                    <NoSSR>
                        <Ad content={fullScreenAd} />
                    </NoSSR>
                )}
                <ChipEdit transform={transform} />
                <NoSSR>
                    <WXGuideLayer
                        wxConfig={wxConfig}
                        base62Id={docData.base62Id}
                        callAppConfig={wxGuideCallAppConfig}
                        clickCallAppConfig={wxGuideClickCallAppConfig}
                        clickContinueConfig={wxGuideClickContinueConfig}
                    />
                </NoSSR>
            </Fragment>
        );
    }
}

export default errorBoundary(Layout);
